import { Button, Form } from "react-bootstrap";
import { useEffect, useRef } from "react";

interface Props {
  userData?: {
    name: string;
  } | null;
  token?: string | null;
  refreshToken?: string | null;
}

// used by internal team to get easy access to the authentication token
export default function Token({ userData, token, refreshToken }: Props) {
  const textAreaRef = useRef<HTMLTextAreaElement>(null);

  function copyToClipboard(value: string) {
    if (textAreaRef.current) {
      textAreaRef.current.value = value;
      textAreaRef.current.select();
      document.execCommand("copy");
    }
  }

  useEffect(() => {
    document.title = "PHIL App - Token";
  }, []);

  return (
    <div className="app_content">
      <h2>
        <small>
          Dear {userData?.name}, you are signed in! <br />
        </small>
        <br />
        Token:
      </h2>
      <Form.Control
        ref={textAreaRef}
        as="textarea"
        rows={10}
        defaultValue={token ?? ""}
        readOnly
      />
      <div className="mt-4 d-flex gap-2">
        <Button variant="primary" onClick={() => copyToClipboard(token ?? "")}>
          Copy Token
        </Button>
        <Button
          variant="primary"
          onClick={() =>
            copyToClipboard(`{"Authorization": "Bearer ${token ?? ""}"}`)
          }
        >
          Copy With Authorization
        </Button>
        <Button
          variant="primary"
          onClick={() => copyToClipboard(refreshToken ?? "")}
        >
          Copy Refresh Token
        </Button>
      </div>
    </div>
  );
}
